import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {Stock} from "../../../../shared/view-model/stock";
import {ApolloQueryObservable} from "apollo-angular";
import {StockService} from "../../../services/stock.service";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {FetchRelatedStocksQuery} from "../../../../shared/graphql/graphql.types";
import {MedicineAuthFormComponent} from "../../../withdrawal/medicine-auth-form/medicine-auth-form.component";

@Component({
  selector: 'vb-move-stock',
  templateUrl: './move-stock.component.html',
  styleUrls: ['./move-stock.component.css']
})
export class MoveStockComponent extends AbstractVisbosComponent implements OnInit, OnChanges {

  enumLabel = (item: Stock) => (item.depot.administration_unit ? item.depot.administration_unit.label + ': ' : '') + item.depot.label + (item.depot_yard ? ": " + item.depot_yard.label : '');
  enumId = (item: Stock) => item.cuid;

  @Input()
  formHorizontal: boolean = true;

  @Input()
  control: FormGroup;

  @Input()
  sourceStock: Stock;

  private sourceStockCuid$: BehaviorSubject<string>;

  private targetStocks$: ApolloQueryObservable<FetchRelatedStocksQuery>;
  public targetStocks: any[];

  constructor(cd: ChangeDetectorRef, sessionActions: SessionActions,
              private fb: FormBuilder, private stockService: StockService) {
    super(sessionActions, cd);

    this.sourceStockCuid$ = new BehaviorSubject(void 0);

  }

  ngOnInit(): void {
    super.ngOnInit();

    this.targetStocks$ = this.stockService.getRelatedStocks(this.sourceStockCuid$);
    this.addComponentData(this.targetStocks$);
    this.addSubscription(this.targetStocks$.subscribe(res => {
      this.targetStocks = res.data.relatedStocks;
    }));

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!this.control) {
      this.control = this.buildControlContent();
    }

    if (changes.sourceStock && this.sourceStock) {
      this.control.get('data.source_stock_cuid').setValue(this.sourceStock.cuid);
      this.fetchRelatedStocks(this.sourceStock.cuid);
    }

  }

  public buildControlContent(): FormGroup {
    return MoveStockComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder): FormGroup {
    return fb.group({
      data: MoveStockComponent.initMoveStockData(fb),
      auth_data: MedicineAuthFormComponent.initControl(fb),
      generate_vouchers: fb.control(false)
    });
  }

  public static initMoveStockData(fb: FormBuilder): FormGroup {
    return fb.group({
      source_stock_cuid: [null, Validators.required],
      target_stock_cuid: [null, Validators.required],
      amount: [null, Validators.required],
    });
  }

  public fetchRelatedStocks(sourceStockCuid: string) {
    this.sourceStockCuid$.next(sourceStockCuid);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/components/move-stock/move-stock.component.ts